'use client'
import { MARK_A, MARK_B, WORDMARK } from '@/lib/logo-paths'
import { useId } from 'react'

/**
 * The Auto.dev lockup as the site draws it (auto.dev src/redesign/kit/Logo.tsx): the two-chevron
 * mark keeps its #B251FF to #8717E0 gradient and the wordmark takes currentColor, so each
 * direction sets the type color in CSS.
 */
export function SiteLogo() {
  // Fumadocs renders the nav title twice (sidebar and phone bar); unique ids keep both gradients
  const id = useId().replace(/[^A-Za-z0-9]/g, '')
  const a = `ad-logo-${id}-a`
  const b = `ad-logo-${id}-b`
  return (
    <svg viewBox='0 0 930 202' className='ad-logo' role='img' aria-label='Auto.dev' fill='none'>
      <path className='ad-logo-mark' d={MARK_A} fill={`url(#${a})`} />
      <path className='ad-logo-mark' d={MARK_B} fill={`url(#${b})`} />
      <path d={WORDMARK} fill='currentColor' />
      <defs>
        <linearGradient id={a} x1='89.6941' y1='74.0845' x2='1.00344' y2='166.999' gradientUnits='userSpaceOnUse'>
          <stop offset='0.113147' stopColor='#B251FF' />
          <stop offset='1' stopColor='#8717E0' />
        </linearGradient>
        <linearGradient id={b} x1='73.3235' y1='127.915' x2='162.014' y2='35.001' gradientUnits='userSpaceOnUse'>
          <stop offset='0.113147' stopColor='#B251FF' />
          <stop offset='1' stopColor='#8717E0' />
        </linearGradient>
      </defs>
    </svg>
  )
}
